import React, { FC } from "react";
import { Alert, Button, Spin } from "antd";

interface FortnoxHeaderProps {
  isConnected: boolean;
  isCheckingConnection: boolean;
  isLoadingUrl: boolean;
  isLoadingLogout: boolean;
  errorMessage: string;
  onLoginClick: () => void;
  onLogoutClick: () => void;
}

const FortnoxHeader: FC<FortnoxHeaderProps> = ({
  isConnected,
  isCheckingConnection,
  isLoadingUrl,
  isLoadingLogout,
  errorMessage,
  onLoginClick,
  onLogoutClick,
}) => {
  if (isCheckingConnection) {
    return (
      <div className="mb-4">
        <Spin size="small" />
      </div>
    );
  }

  return (
    <div className="mb-4">
      <Alert
        message={
          <div className="flex items-center justify-between">
            <span>
              {isConnected ? (
                <span className="font-medium text-green-600">
                  Login to Fortnox:{" "}
                  <span className="text-green-700">Logged In</span>
                </span>
              ) : (
                <span className="font-medium text-red-600">
                  Login to Fortnox:{" "}
                  <span className="text-red-700">Not Logged In</span>
                  {errorMessage && errorMessage !== "Not connected" && (
                    <span className="ml-2 text-sm">({errorMessage})</span>
                  )}
                </span>
              )}
            </span>
            {!isConnected && (
              <Button
                type="primary"
                size="small"
                onClick={onLoginClick}
                loading={isLoadingUrl}
                className="ml-4"
              >
                Login to Fortnox
              </Button>
            )}
            {isConnected && (
              <Button
                type="primary"
                danger
                size="small"
                onClick={onLogoutClick}
                loading={isLoadingLogout}
                className="ml-4"
              >
                Log Out
              </Button>
            )}
          </div>
        }
        type={isConnected ? "success" : "error"}
        showIcon
        className="border-2"
      />
    </div>
  );
};

export { FortnoxHeader };
